import dayjs from "dayjs";
import type { Dayjs } from "dayjs";

/** Coerce API / form values to a trimmed string for controlled inputs. */
export const stringFromUnknown = (value: unknown): string => {
  if (value == null) return "";
  if (typeof value === "string") return value.trim();
  return String(value).trim();
};

/** Normalize stored yes/no / boolean to "", "Yes", or "No" for select fields. */
export const yesNoStringFromStored = (value: unknown): string => {
  if (value == null || value === "") return "";
  const s = String(value).trim().toLowerCase();
  if (s === "yes" || s === "y" || s === "true" || value === true) return "Yes";
  if (s === "no" || s === "n" || s === "false" || value === false) return "No";
  return "";
};

export const storedToDayjsOrNull = (value: unknown): Dayjs | null => {
  if (value == null || value === "") return null;
  if (dayjs.isDayjs(value)) return value.startOf("day");
  const d = dayjs(value as string | number | Date);
  return d.isValid() ? d.startOf("day") : null;
};

/** Persist calendar day as ISO (start of day) for payloads; null when cleared. */
export const dayjsStartOfDayToIso = (d: Dayjs | null): string | null => {
  if (d == null) return null;
  const x = dayjs.isDayjs(d) ? d : dayjs(d);
  if (!x.isValid()) return null;
  return x.startOf("day").toISOString();
};

const currentDate = new Date().toISOString().split("T")[0];
export const propertyTime = {
  CHECK_IN: dayjs(`${currentDate}T15:00`),
  CHECK_OUT: dayjs(`${currentDate}T12:00`),
};

export const GolfPropertyTime = {
  TIME: dayjs(`${currentDate}T15:00`),
  StartTime: dayjs(`${currentDate}T15:00`),
  EndTime: dayjs(`${currentDate}T15:00`),
};

export const converttoStandardTime = (day: any) => {
  return day.$d.toISOString();
};

export const converttoDayjsTime = (day: any) => {
  return dayjs(day);
};

export const ScoringMethod = ["Stroke", "Match Play", "Other"];
export const GroupFormats = ["Individual", "Team"];
export const Scores = ["Gross", "Net"];
